import PropTypes from 'prop-types';
import { useEffect, useMemo, useRef } from 'react';
import clsx from 'clsx';
import ReactPaginate from 'react-paginate';
import Arrow from '@assets/icons/arrow.svg';
import { useSignaturesPaginationContext } from 'context/SignaturesPaginationContext';
import styles from './TablePagination.module.scss';

const TablePagination = ({ pages, hasNext, hasPrevious, fetchPage }) => {
  const lastCountRef = useRef();
  const { page: pageNumber, setPage } = useSignaturesPaginationContext();

  useEffect(() => {
    lastCountRef.current = pages;
  }, [pages]);

  const handlePageClick = event => {
    setPage(event.selected + 1);
    fetchPage(event.selected + 1);
  };

  const pageCount = useMemo(() => pages || lastCountRef.current, [pages]);

  const ArrowComp = () => <Arrow height={16} width={16} stroke='#969696' />;

  return (
    <div className={styles.container}>
      <button
        className={clsx(
          !hasPrevious && styles.disabled,
          styles.doubleArrow,
          'rotate180',
        )}
        onClick={() => handlePageClick({ selected: 0 })}
      >
        <ArrowComp />
        <ArrowComp />
      </button>
      <ReactPaginate
        breakLabel='...'
        nextLabel={<ArrowComp />}
        previousLabel={<ArrowComp />}
        onPageChange={handlePageClick}
        pageRangeDisplayed={1}
        marginPagesDisplayed={2}
        pageCount={pageCount || 1}
        forcePage={pageNumber - 1}
        renderOnZeroPageCount={null}
        pageClassName={'subtitle1'}
        pageLinkClassName={styles.button}
        previousLinkClassName={clsx(
          !hasPrevious && styles.disabled,
          styles.button,
          'subtitle1',
          'rotate180',
        )}
        nextLinkClassName={clsx(
          !hasNext && styles.disabled,
          styles.button,
          'subtitle1',
        )}
        breakClassName={'subtitle1'}
        containerClassName={clsx(
          styles.pagination,
          pageCount > 5 && styles.paginationBig,
        )}
        activeClassName={styles.current}
      />
      <button
        className={clsx(!hasNext && styles.disabled, styles.doubleArrow)}
        onClick={() => handlePageClick({ selected: pages - 1 })}
      >
        <ArrowComp />
        <ArrowComp />
      </button>
    </div>
  );
};

TablePagination.propTypes = {
  pages: PropTypes.number,
  hasPrevious: PropTypes.bool,
  hasNext: PropTypes.bool,
  fetchPage: PropTypes.func,
};

export default TablePagination;
